import React from 'react';
import classNames from 'classnames';
import speciesImageUrl from 'src/assets/images/dashboard/species.svg?url';
import styles from './MetricCard.module.scss';
export interface CardProps {
    header: string;
    logo?: React.ReactNode;
    content?: string | React.ReactNode;
    helpText?: React.ReactNode;
    total?: number;
    average?: number;
    backgroundImage?: string;
    noData?: boolean;
    footer?: React.ReactNode;
    hideBackgroundImage?: boolean;
    classes?: {
        content?: string;
    };
}

const MetricCard = (props: CardProps) => {
    const {
        header,
        logo,
        content,
        helpText,
        total,
        noData = false,
        backgroundImage = speciesImageUrl,
        footer,
        hideBackgroundImage,
        classes,
    } = props;

    const backgroundImageStyle = !hideBackgroundImage
        ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '150% center',
              backgroundSize: '50% 100%',
          }
        : undefined;

    const testId = `metric-card-${header.replace(/\s/g, '-').toLowerCase()}`;

    return (
        <div className={styles.card} style={backgroundImageStyle} data-testid={testId}>
            <div className={styles.header}>
                {logo}
                <span className={styles.title} data-testid='metric-card-title'>
                    {header}
                </span>
                <span className={styles.questionButton}>{helpText}</span>
            </div>

            <div className={classNames(styles.content, classes?.content)}>
                {noData ? (
                    <>
                        <div className={styles.noDataContent}>There is insufficient data to display this chart</div>
                    </>
                ) : (
                    <>
                        {total !== undefined ? (
                            <div className={styles.number} data-testid='metric-card-total'>
                                {total}
                            </div>
                        ) : null}
                        <div className={styles.text} data-testid='metric-card-content'>
                            {content}
                        </div>
                        {footer}
                    </>
                )}
            </div>

            {noData && (
                <div className={styles.footer}>
                    <span>Speak to our customer success team on how to update your sampling plan</span>
                </div>
            )}
        </div>
    );
};

export default MetricCard;
